export default "__VITE_ASSET__BEGPYqy7__"